import { Storage } from "@xt/xtbase";

const RECOMMENDED_FIAT_PLATE_ID = 258;

function getRecommendedCurrencies() {
  const payload = Storage.get("recommendedCurrencyList") || {};
  return Array.isArray(payload.currencies) ? payload.currencies : [];
}

export function getDynamicFiatMarketCodes() {
  const currencies = getRecommendedCurrencies();
  const codes = [];
  currencies.forEach((item) => {
    const code = String(item?.currency || item?.currencyCode || item?.coinName || "").toUpperCase();
    const plates = Array.isArray(item?.plates) ? item.plates : [];
    const isFiat = plates.some((plateId) => Number(plateId) === RECOMMENDED_FIAT_PLATE_ID);
    if (isFiat && code && !codes.includes(code)) {
      codes.push(code);
    }
  });
  return codes;
}

export function isFiatMarketCode(code) {
  if (!code) return false;
  return getDynamicFiatMarketCodes().includes(String(code).toUpperCase());
}
